// extracted by mini-css-extract-plugin
export default {"container":"PinIconSettings_container__kVus-"};